import React, { useContext, useState, useEffect } from 'react';
import AppContext from "../../../state/AppContext";
import APIInvoke from '../../../utils/APIInvoke';
import { IconButton, Paper, Tooltip } from '@mui/material';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import GridOnIcon from '@mui/icons-material/GridOn';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import Heatmap2d from './Heatmap2d';
import Heatmap3d from './Heatmap3d';
import { DateTime } from 'luxon';

const Heatmap = (props) => {

    const [data, setData] = useState([]);
    const { appContext } = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [showView, setShowView] = useState('2d');

    // Efecto para actualizar el contador cada 10 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isRunning) return;
            fetchData();
        }, 10000);

        // Limpieza del intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, [isRunning]);

    useEffect(() => {
        if (loading) return;
        fetchData();
    }, [appContext.project]);

    const fetchData = async () => {
        try {
            setLoading(true)
            const now = DateTime.now().startOf('day');
            const startDate = now.minus({ days: 6 }).startOf('day').toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss");
            const endDate = now.endOf('day').toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss");
            const response = await (await APIInvoke.invokeGET(`/projects/${appContext.project}/dashboard/events/hourly?start=${startDate}&end=${endDate}`)).json();
            setData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div >
            <Paper className=" ">
                <div className="px-4 bg-gray-100 p-2 border-t border-gray-300 flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center">
                        <GridOnIcon fontSize="medium" className="text-dark-500" />
                        <span className="pl-2 mr-4">Last 7 days activity</span>
                    </div>
                    <div>
                        <IconButton onClick={() => setShowView(showView === '2d' ? '3d' : '2d')}>
                            {showView === '2d'
                                ? <ThreeDRotationIcon fontSize="medium" className="text-dark-500" />
                                : <ViewComfyIcon fontSize="medium" className="text-dark-500" />
                            }
                        </IconButton>
                        <Tooltip title={isRunning ? "Stop" : "Start"} className="flex items-center">
                            <IconButton onClick={() => setIsRunning(!isRunning)}>
                                {isRunning
                                    ? <StopCircleIcon className={isRunning ? "text-red-500 animate-pulse" : "text-red-500"} fontSize="medium" />
                                    : <PlayCircleIcon className="text-green-500" fontSize="medium" />}
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
                {showView === '2d' && <div className="p-4">
                    <Heatmap2d rawData={data} isRunning={isRunning} loading={loading} project={appContext.project} />
                </div>}
                {showView === '3d' && <div className="p-4 h-[630px]">
                    <Heatmap3d rawData={data} isRunning={isRunning} loading={loading} project={appContext.project} />
                </div>}
            </Paper>
        </div >

    );
}
export default Heatmap;





